/**
 * 费用计算
 * 承运人运费 | 托运方运费 --> 计算逻辑一样
 * 总运费
 * 服务费
 *
 * 服务费
 *  1.
 */
import BigNumber from 'bignumber.js';
import Utils from '../Utils';
// import Utils from '../Utils'

// 服务费率配置方式
const ServiceCostsTaxTypes = {
  TaxInclusive: 1, // 含税 (默认)
  TaxExclusive: 2 // 不含税
};

// 服务费舍去模式
const ServiceCostsRoundingTypes = {
  10: BigNumber.ROUND_CEIL, // 向上取整 （默认）
  20: BigNumber.ROUND_HALF_CEIL, // 四舍五入
  30: BigNumber.ROUND_FLOOR // 向下取整
};

const OppositeRoundingMap = {
  10: BigNumber.ROUND_FLOOR,
  20: BigNumber.ROUND_HALF_FLOOR,
  30: BigNumber.ROUND_CEIL
};

// 打个补丁吧，根据【carrier_cost_exceed_system】1: 不允许 2:允许
// 能否超出运费最大值
// function allowCarrierCostExceed() {
//   return +userStore.config.carrier_cost_exceed_system === 2;
// }

// 输入的值能否超出计价规则算出的运费
const CostsExcessTypes = {
  NotAllowExcess: 1, // 不允许超出
  AllowExcess: 2 // 允许超出 (默认)
};

const ActiveNames = {
  CarrierTransportCost: 'carrierTransportCost',
  ShipperTransportCost: 'shipperTransportCost',
  Cost: 'cost',

  TotalCost: 'totalCost'
};

export default class Costs {
  constructor() {
    // 服务费取值模式(默认向上取整)
    this.serviceCostsRoundingType = 10;
    // 服务费税率配置
    this.serviceCostsTaxType = ServiceCostsTaxTypes.TaxInclusive;
    // 服务费比率
    this.serviceCostsRate = 0;

    // 运费超出配置（默认允许超出）
    this.costsExcessType = CostsExcessTypes.AllowExcess;

    // 输入表单处理
    this.form = {
      name: '',
      value: null
    };

    this.maxCosts = null;
  }

  setRules(rules) {
    const { serviceCostsRoundingType, serviceCostsTaxType, costsExcessType, serviceCostsRate } = rules;
    this.serviceCostsRate = new BigNumber(serviceCostsRate || 0).toNumber();
    this.serviceCostsRoundingType = serviceCostsRoundingType ?? null;
    this.serviceCostsTaxType = serviceCostsTaxType ?? this.serviceCostsTaxType;
    this.costsExcessType = costsExcessType ?? CostsExcessTypes.AllowExcess;
    return this;
  }

  // 设置最大值，根据规则限制运费
  setMaxCosts(maxCosts) {
    if (this.costsExcessType === CostsExcessTypes.NotAllowExcess) {
      this.maxCosts = maxCosts ?? null;
    } else {
      this.maxCosts = null;
    }

    return this;
  }

  setValues({ name, value }) {
    this.form.name = name;
    this.form.value = value;
    return this;
  }

  build() {
    let resultMap = { totalCosts: null, costs: null, serviceCosts: null };
    // 输入运费，计算服务费和总运费
    const { name, value } = this.form;
    if (!Utils.isNumber(value)) return resultMap;

    const isCostsInput =
      name === ActiveNames.CarrierTransportCost ||
      name === ActiveNames.ShipperTransportCost ||
      name === ActiveNames.Cost;

    if (isCostsInput) {
      resultMap.costs = Utils.isNumber(this.maxCosts) ? Math.min(Number(this.maxCosts), Number(value)) : Number(value);
      resultMap.totalCosts = this.getTotalCosts(resultMap.costs);
      resultMap.serviceCosts = this.getServiceCosts(resultMap.costs, resultMap.totalCosts);
      return resultMap;
    }

    if (name === ActiveNames.TotalCost) {
      resultMap.totalCosts = Number(value);
      resultMap.costs = this.getCosts(resultMap.totalCosts);

      if (Utils.isNumber(this.maxCosts) && Number(this.maxCosts) < resultMap.costs) {
        resultMap.costs = Number(this.maxCosts);
        resultMap.totalCosts = this.getTotalCosts(resultMap.costs);
      }
      resultMap.serviceCosts = this.getServiceCosts(resultMap.costs, resultMap.totalCosts);

      return resultMap;
    }
    return resultMap;
  }

  getCosts(totalCosts) {
    const costRate = new BigNumber(
      this.serviceCostsTaxType === ServiceCostsTaxTypes.TaxInclusive
        ? 10000 - this.serviceCostsRate
        : 10000 + this.serviceCostsRate
    )
      .dividedBy(10000)
      .decimalPlaces(4);

    const bigTotalCost = new BigNumber(+totalCosts);
    const BigTransportCost =
      this.serviceCostsTaxType === ServiceCostsTaxTypes.TaxInclusive
        ? bigTotalCost.multipliedBy(costRate)
        : bigTotalCost.dividedBy(costRate);
    const carrierTransportCost = BigTransportCost.integerValue(
      OppositeRoundingMap[this.serviceCostsRoundingType]
    ).toNumber();

    return carrierTransportCost;
  }

  getServiceCosts(costs, totalCost) {
    const serviceCost = new BigNumber(+totalCost)
      .minus(+costs)
      .integerValue(ServiceCostsRoundingTypes[this.serviceCostsRoundingType])
      .toNumber();

    return serviceCost;
  }

  getTotalCosts(costs) {
    const costRate = new BigNumber(
      this.serviceCostsTaxType === ServiceCostsTaxTypes.TaxInclusive
        ? 10000 - this.serviceCostsRate
        : 10000 + this.serviceCostsRate
    )
      .dividedBy(10000)
      .decimalPlaces(4);

    const bigTransportCost = new BigNumber(+costs);
    const bigTotalCost =
      this.serviceCostsTaxType === ServiceCostsTaxTypes.TaxInclusive
        ? bigTransportCost.dividedBy(costRate)
        : bigTransportCost.multipliedBy(costRate);
    const totalCost = bigTotalCost.integerValue(ServiceCostsRoundingTypes[this.serviceCostsRoundingType]).toNumber();

    return totalCost;
  }
}
